import { useAuth0 } from "@auth0/auth0-react";

import { noop, noopAsync } from "./authUtils";

const FALLBACK_AUTH0_CONTEXT = {
  isAuthenticated: false,
  user: null,
  getAccessTokenSilently: noopAsync,
  loginWithRedirect: noop,
  logout: noop,
  isLoading: false,
};

export default function useOptionalAuth0() {
  try {
    return useAuth0();
  } catch {
    return FALLBACK_AUTH0_CONTEXT;
  }
}
